
export default [
    {
        path: '/dataList/inventory/inventoryBill',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '出入库记录',
            keepAlive: false
        }
    },
];
  